"use client";

import { useContext } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import MenuContext from "@/context/MenuProvider";
import { Stack } from "@mui/material";
import Link from "next/link";

const menus = [
  { title: "Beranda", path: "/", anchor: null },
  { title: "Tentang Kami", path: null, anchor: "subAppBarTentangKami" },
  { title: "Koleksi", path: "/koleksi", anchor: null },
  { title: "Layanan", path: null, anchor: "subAppBarLayanan" },
  { title: "Bantuan", path: null, anchor: "subAppBarBantuan" }
];

// Define the initial state structure
const initialState = {
  subAppBarTentangKami: false,
  subAppBarFasilitas: false,
  subAppBarLayanan: false,
  subAppBarKoleksi: false,
  subAppBarBantuan: false
};

const UserNavbarTopCenter = () => {
  // const navigate = useNavigate();
  const { setStateAppBar } = useContext(MenuContext)!;

  const toggleSubAppBar = (anchor: keyof typeof initialState, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (event.type === "keydown" && "key" in event && (event.key === "Tab" || event.key === "Shift")) return;
    setStateAppBar((prevState) => ({ ...prevState, [anchor]: open }));
  };

  const closeSubAppBar = () => {
    setStateAppBar({
      subAppBarTentangKami: false,
      subAppBarFasilitas: false,
      subAppBarLayanan: false,
      subAppBarKoleksi: false,
      subAppBarBantuan: false
    });
  };

  return <Box>
    <Stack
      component="a"
      href="/"
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{ textDecoration: "none", display: { xs: "flex", md: "none" } }}
    >
      <img src="/image/Logo.png" alt="Logo SIMPus" width="40" height="40"/>
      <Typography
        sx={{
          fontSize: "34px",
          color: "black",
          display: { xs: "none", md: "block" }
        }}
      >
        SIMPus
      </Typography>
    </Stack>
    <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
      {menus.map((menu, key) => (
        <Button
          key={key}
          sx={{
            color: "inherit",
            textDecoration: 'inherit',
            display: "flex",
            height: "64px"
          }}
          href={menu.path || undefined}
          component={menu.path !== null ? Link : "button"}
          onMouseOver={
            menu.anchor !== null
              ? toggleSubAppBar(menu.anchor as keyof typeof initialState, true)
              : undefined
          }
          onMouseOut={menu.anchor !== null ? closeSubAppBar : undefined}
        >
          {menu.title}
        </Button>
      ))}
    </Box>
  </Box>;
};

export default UserNavbarTopCenter;
